import { schema as schemas } from 'normalizr'
import { CallApi } from '@signavio/kraken'

import { ADMIN_API_BASE } from '../../callApi'

export const collection = 'licenseProfiles'

const licenseProfileSchema = new schemas.Entity(collection)

export const schema = new schemas.Array(licenseProfileSchema)

export const fetch = (callApi: CallApi) => () => {
  return callApi(`${ADMIN_API_BASE}/licenseProfiles`, schema)
}

export const create =
  (callApi: CallApi) =>
  (
    _: unknown,
    {
      organizationId,
      licenseProfileId,
    }: { organizationId: string; licenseProfileId: string }
  ) => {
    return callApi(
      `${ADMIN_API_BASE}/organizations/${organizationId}/licenseProfiles/${licenseProfileId}`,
      schema,
      { method: 'POST' }
    )
  }
